
import { JSModule } from "./core/types/JSModule";
import { isTouchDevice } from "./utils/screens";

/**
 * The following blocks handle processing and project structure
 *
 * You can modify those to suit your needs ; for a quick setup, just change the JS modules list.
 */
/** Javascript modules to load */
const modules: JSModule[] = [
    {
        selector: "[data-main-header]",
        fileToLoad: "./header"
    },
    {
        selector: "swiper-container",
        fileToLoad: "./slider"
    },
    {
        selector: '[gsap-text]',
        fileToLoad: "./gsap/text"
    },
    {
        selector: '[data-matter-gravity]',
        fileToLoad: "./matter/init",
        // Currently only used in the footer's falling-badges effect, so it's
        // otherwise fetched on every single page whether or not the visitor
        // ever scrolls that far — matter-js is the single heaviest chunk in
        // the build.
        loadWhenVisible: true
    },
    {
        selector: ".p-counter",
        fileToLoad: "./key-numbers"
    },
    {
        selector: '[data-tooltip]',
        fileToLoad: "./tooltip"
    },
    {
        selector: '[data-product-form]',
        fileToLoad: "./forms"
    },
    {
        selector: '[data-tabs]',
        fileToLoad: "./tabs"
    },
    {
        selector: '[data-details-group]',
        fileToLoad: "./accordion"
    }
];
modules.forEach((m) => {
    // Check if we need specific elements in the page
    let elementsToCheck = null;
    if (m.selector) {
        elementsToCheck = document.querySelector(m.selector);
    }

    // Import only if no selector was specified or the elements were found in the page
    if (!m.selector || (m.selector && elementsToCheck)) {
        const loadModule = () => import(
            /* webpackChunkName: "[request]", webpackMode: "lazy", webpackFetchPriority: "high" */
            `${m.fileToLoad}`
        );

        if (m.loadWhenVisible && elementsToCheck) {
            loadModuleWhenVisible(elementsToCheck, loadModule);
        } else {
            loadModule();
        }
    }
});

/**
 * Defers fetching a module's chunk until `el` scrolls near the viewport,
 * instead of as soon as it's found in the DOM — for below-the-fold modules
 * whose payload is too heavy to justify downloading on every page load
 * regardless of whether the visitor ever scrolls that far.
 */
function loadModuleWhenVisible(el: Element, load: () => void) {
    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            load();
            observer.disconnect();
            break;
        }
    }, { rootMargin: "500px 0px" });

    observer.observe(el);
}

/** Load all images in directory `src/images` for processing through webpack */
function importImages(r: __WebpackModuleApi.RequireContext) {
    return r.keys().map(r);
}
importImages(require.context("../images", true, /\.(png|svg|jpg|jpeg|gif)$/i));

/* Setup the HTML initial properties */
const html = document.documentElement;

/* Remove .no-js on the HTML tag if we can load it */
html.classList.remove("no-js");
html.classList.add("js");

/* Change touch classes on the HTML tag */
if (isTouchDevice()) {
    html.classList.remove("no-touch");
    html.classList.add("touch");
} else {
    html.classList.add("no-touch");
    html.classList.remove("touch");
}

/* Fin du setup ! Vous pouvez coder après ce commentaire ou rajouter des modules dans la liste plus haut. */
